<template>
  <div >
    <HomeDetailInfoSiteOne>
      <template #header-one>
        <h1 :style="`
        ${$vuetify.breakpoint.smAndDown ? '' : 'padding: 30px 30px 30px 30px;'}`"> The Power of the workpackage status </h1>
      </template>
      <template #text-one>
        <p :style="`max-width: 700px;
        font-style: normal;
        font-size: 20px;

        ${$vuetify.breakpoint.smAndDown ? 'padding: 20px 20px 20px 20px' : 'padding: 40px 20px 30px 20px;'}`">
          Use the status of the workpackages to gain overview and steer your site. Integrate the subcontractors into the workflow and the discussions.
        </p>
      </template>
      <template #image>
        <img :width="$vuetify.breakpoint.smAndDown ? '100%' : '70%'" src="@/assets/PowerOfTakt-TaktControlOne.png">
      </template>
    </HomeDetailInfoSiteOne>
    <HomeDetailInfoSiteOne>
      <!-- <template #header-one>
        <h1> The Power of the workpackage status </h1>
      </template> -->
      <template #text-one>
        <p :style="`max-width: 700px;
        font-style: normal;
        font-size: 20px;

        ${$vuetify.breakpoint.smAndDown ? 'padding: 20px 20px 20px 20px' : 'padding: 40px 20px 30px 20px;'}`">
        Balance the resources like manpower, needed hours, materials etc.
        </p>
      </template>
      <template #image>
        <img :width="$vuetify.breakpoint.smAndDown ? '100%' : '70%'" src="@/assets/PowerOfTakt-TaktControlTwo.png">
      </template>
    </HomeDetailInfoSiteOne>
    <HomeDetailInfoSiteOne>
      <!-- <template #header-one>
        <h1> The Power of the workpackage status </h1>
      </template> -->
      <template #text-one>
        <p :style="`max-width: 700px;
        font-style: normal;
        font-size: 20px;

        ${$vuetify.breakpoint.smAndDown ? 'padding: 20px 20px 20px 20px' : 'padding: 40px 20px 30px 20px;'}`">
        Filter your Taktplan and create an flow from the subcontractor perspective. It’s a great opportunity to show roadblocks or critical points.
        </p>
      </template>
      <template #image>
        <img :width="$vuetify.breakpoint.smAndDown ? '100%' : '70%'" src="@/assets/PowerOfTakt-TaktControlThree.png">
      </template>
    </HomeDetailInfoSiteOne>
  </div>
</template>

<script>
import HomeDetailInfoSiteOne from '@/components/Home/HomeDetailInfoSiteOne.component.vue'

export default {
  components: {
    HomeDetailInfoSiteOne
  }
}
</script>
